// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import accessTokenService from "../../utils/AccessTokenService";
import { imageToBase64, objectToFormData } from "utils/Utils";

// initialize an empty api service that we'll inject endpoints into later as needed
export const localApi = createApi({
    reducerPath: "local",
    baseQuery: fetchBaseQuery({
        baseUrl: "http://localhost:7070",
        //baseUrl: "https://url-scraper.is.symboolic.com",
        credentials: "include",
        prepareHeaders: async (headers) => {
            const token =
                "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImJSZ2UtM3BLTlV2bGNzRmFQbVFVTSJ9.eyJpc3MiOiJodHRwczovL3N5bWJvb2xpYy5ldS5hdXRoMC5jb20vIiwic3ViIjoiNmdBcWhxdGc1VTliNkY1TUtyc0YySnAybDduSjEzbkdAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vdXJsLXNjcmFwZXIuaXMuc3ltYm9vbGljLmNvbSIsImlhdCI6MTcxMjg0ODMwNywiZXhwIjoxNzEyOTM0NzA3LCJndHkiOiJjbGllbnQtY3JlZGVudGlhbHMiLCJhenAiOiI2Z0FxaHF0ZzVVOWI2RjVNS3JzRjJKcDJsN25KMTNuRyJ9.nhgKRYWzfRZfGYehIpBEZ6y7g1skm5ScHz04IIXb7SZ2OVO9NSzde5MMAOw1OWwipWKkLblIfM3W1f2axf9U2Ohy0iKXBp0dkdVfem6EN3Zlt7_Nq3IDNyzFMEQW1rhReKewiYPW1Y3D8EVbRM41164Gb1VDhuTe8U0Ee2rJWnNVG_Mom5WBnCf3Tp4g8TRkMmRn65UmmNQGhLc6FRmN6wcfApxBCuRXl4kd4hsOXKgJcZVRx1EJipz7RvrJDfsBD4gInlps9BRT5jZNApGGhObefClNHh3gtHoIUgKf7I8I906R0nR0fzLTkROg0vXiIeq8nWA08t30ktB8dPGiNg";
            headers.set("Authorization", token ? `Bearer ${token}` : "");
            return headers;
        }
    }),
    endpoints: (builder) => ({
        pagePreview: builder.mutation<any, PagePreviewArgs>({
            query: (args) => ({
                url: "page-preview",
                method: "POST",
                body: objectToFormData(args),
                responseHandler: async (response: Response) => {
                    const image = await response.blob();
                    return imageToBase64(image);
                }
            })
        }),
        sectionPreview: builder.mutation<any, SectionPreviewArgs>({
            query: (args) => ({
                url: "section-preview",
                method: "POST",
                body: objectToFormData(args),
                responseHandler: async (response: Response) => {
                    const image = await response.blob();
                    return imageToBase64(image);
                }
            })
        })
    })
});

export type PagePreviewArgs = {
    url: string;
};

export type SectionPreviewArgs = PagePreviewArgs & {
    x: number;
    y: number;
    width: number;
    height: number;
};

export const { usePagePreviewMutation, useSectionPreviewMutation } = localApi;
